import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { adminService } from '../services/admin.service';
import LoadingSpinner from './LoadingSpinner';

const AdminRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        const token = localStorage.getItem('adminToken');
        if (!token) {
          setIsAuthenticated(false);
          return;
        }

        const isValid = await adminService.verifyToken(token);
        setIsAuthenticated(isValid);

        if (!isValid) {
          localStorage.removeItem('adminToken');
          navigate('/pmpl/admin');
        }
      } catch (error) {
        console.error('Error verificando autenticación:', error);
        setIsAuthenticated(false);
        localStorage.removeItem('adminToken');
        navigate('/pmpl/admin');
      }
    };

    verifyAuth();
  }, [navigate]);

  if (isAuthenticated === null) {
    return <LoadingSpinner />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/pmpl/admin" replace />;
};

export default AdminRoute; 